import { 
  LayoutDashboard, 
  FileText, 
  Users, 
  BarChart3, 
  Zap, 
  BookOpen, 
  CreditCard,
  Brain,
  Calculator,
  Menu
} from "lucide-react";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarTrigger,
} from "@/components/ui/sidebar"
import { useIsMobile } from "@/hooks/use-mobile"



const menuItems = [
  { id: "dashboard", title: "Dashboard", icon: LayoutDashboard },
  { id: "listings", title: "Listings", icon: FileText },
  { id: "leads", title: "Leads", icon: Users },
  { id: "reports", title: "Reports", icon: BarChart3 },
  { id: "ai-matching", title: "AI Business Matching", icon: Brain },
  { id: "ai-valuation", title: "AI Valuation", icon: Calculator },
  { id: "boost", title: "Boost & Promotions", icon: Zap },
  { id: "resources", title: "Resources", icon: BookOpen },
  { id: "billing", title: "Billing & Settings", icon: CreditCard },
];

interface BrokerSidebarProps {
  activeSection: string;
  onSectionChange: (section: string) => void;
}

export function BrokerSidebar({ activeSection, onSectionChange }: BrokerSidebarProps) {
  return (
    <Sidebar 
      data-sidebar="sidebar"
      className="w-64 border-r" 
      collapsible="icon"
      style={{ position: 'sticky', top: '176px', height: 'calc(100vh - 176px)', zIndex: 30 }}
    >
      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupLabel>Broker Portal</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {menuItems.map((item) => (
                <SidebarMenuItem key={item.id}>
                  <SidebarMenuButton 
                    onClick={() => onSectionChange(item.id)}
                    data-active={activeSection === item.id}
                  >
                    <item.icon className="mr-2 h-4 w-4" />
                    <span>{item.title}</span>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  );
}